import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=513f5df0&"
import script from "./PricingCard.vue?vue&type=script&lang=ts&"
export * from "./PricingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports